export const interior_view01ImageOptions = {
  angle: 'interior_view01',
  staticOptions: {
    Floorboard: 1,
    Fabric: 1,
    FabricOwnersCabin: 1,
    CupboardsOwnersCabin: 1,
    BedsideCompartment: 1,
    Wardrobe: 1,
    AftCabinLayout: 1,
    Mast: 1,
    Wheel: 1,
    FabricSeatOwnersCabin: 1,
    FabricFreehung: 1
  },
  mattes: [
    {
      option: 'Fabric',
      dependency: 'AftCabinLayout'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Xc47/views/interior_view01.js